export const trackPage = (): boolean =>
  document.dispatchEvent(
    new CustomEvent("c-tracking-log-page", {
      bubbles: true,
    })
  );
